import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import CommentItem from './CommentItem'
import './CommentList.scss'
import $ from 'jquery'
import jQuery from 'jquery'
import { withCookies, Cookies } from 'react-cookie'
import { deepCopy } from '../../Libs/Utils'

class CommentList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isSimple: false,
            isReply: true,
            input: {
                content: '',
                focus: false,
                files: [],
            },
            comments: [],
            deletePopId: null,
            user: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })
                this.loadComment()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadComment = () => {
        let url = `${BACKEND_HOST}/comments/?parentEntity=${this.props.url}&parent_id=${this.props.id}`

        axios
            .get(url, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                let comments = res.data

                for (let i = 0; i < res.data.length; i += 1) {
                    comments[i]['reInput'] = { content: '', files: [], modify: false, focus: false }
                    for (let j = 0; j < res.data[i].childComments.length; j += 1) {
                        comments[i].childComments[j]['reInput'] = {
                            content: '',
                            files: [],
                            modify: false,
                            focus: false,
                        }
                    }
                }
                this.setState({ comments })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    addComment = (i, j) => {
        if (i === null) {
            // 댓글
            if (this.state.input.content === '') {
                alert('댓글을 입력해주세요.')
                return
            }

            let data = {
                content: this.state.input.content,
                files: this.state.input.files,
                parent_id: this.props.id,
                parentEntity: this.props.url,
            }

            // console.log(data)

            axios
                .post(`${BACKEND_HOST}/comments/`, data, {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                })
                .then((res) => {
                    // console.log(res)
                    this.setState({ input: { content: '', focus: false, files: [] } })

                    this.loadComment()
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            let data = {}
            if (j < 0) {
                data = {
                    parentEntity: 'COMMENT',
                    content: this.state.comments[i].reInput.content,
                    files: this.state.comments[i].reInput.files,
                    parent_id: this.state.comments[i]._id,
                }
            } else {
                data = {
                    parentEntity: 'COMMENT',
                    content: this.state.comments[i].childComments[j].reInput.content,
                    files: this.state.comments[i].childComments[j].reInput.files,
                    parent_id: this.state.comments[i].childComments[j]._id,
                }
            }

            if (data.content === '') {
                alert('댓글을 입력해주세요.')
                return
            }

            axios
                .post(`${BACKEND_HOST}/comments/`, data, {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                })
                .then((res) => {
                    this.loadComment()
                    $('.recomment_input_wrap').hide()
                    $('.recomment_re_input_wrap').hide()
                })
                .catch((err) => {
                    console.log(err)
                })
        }

        if (this.state.isSimple) {
            this.setState({
                isSimple: false,
            })
        }
    }

    deleteComment = (commentId) => {
        axios
            .delete(`${BACKEND_HOST}/comments/${commentId}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.loadComment()
                this.setState({ deletePopId: null })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    modifyComment = (i, j) => {
        let item = {}
        if (j < 0) {
            item = this.state.comments[i]
        } else {
            item = this.state.comments[i].childComments[j]
        }
        if (item.reInput.content === '') {
            alert('댓글을 입력해주세요.')
            return
        }

        let data = {
            content: item.reInput.content,
            files: item.reInput.files,
        }

        axios
            .patch(`${BACKEND_HOST}/comments/${item._id}`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.loadComment()
                $('.recomment_input_wrap').hide()
                $('.recomment_re_input_wrap').hide()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    onFocus = () => {
        const input = this.state.input
        input['focus'] = true

        this.setState({
            input,
            isReply: true,
        })
    }

    onBlur = () => {
        this.setState({ input: { content: '', focus: false, files: [] } })
    }

    fileUpload = (e) => {
        e.preventDefault()

        const thumbnail = document.querySelector('input[name="file"]').files[0]
        const data = new FormData()
        data.append('file', thumbnail)

        axios
            .post(`${BACKEND_HOST}/upload/files/`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const input = this.state.input
                input['files'] = res.data
                this.setState({
                    input,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteFile = () => {
        const input = this.state.input
        input['files'] = []

        this.setState({
            input,
        })
    }

    reChangeData = (event, i, j) => {
        const { comments } = this.state
        const nextComments = deepCopy(comments)
        if (j < 0) {
            nextComments[i]['reInput']['content'] = event.target.value
        } else {
            nextComments[i].childComments[j]['reInput']['content'] = event.target.value
        }

        this.setState({
            comments: nextComments,
        })
    }

    reOnFocus = (i, j) => {
        const { comments } = this.state
        let nextComments = deepCopy(comments)
        if (j < 0) {
            nextComments[i]['reInput']['focus'] = true
        } else {
            nextComments[i].childComments[j]['reInput']['focus'] = true
        }

        this.setState({
            comments: nextComments,
            isReply: false,
        })
    }

    reOnBlur = (i, j) => {
        $('.recomment_input_wrap').hide()
        $('.recomment_re_input_wrap').hide()
        const { comments } = this.state
        let nextComments = deepCopy(comments)
        if (j < 0) {
            nextComments[i]['reInput'] = { content: '', files: [], modify: false, focus: false }
        } else {
            nextComments[i].childComments[j]['reInput'] = { content: '', files: [], modify: false, focus: false }
        }

        this.setState({ comments: nextComments })
    }

    openReInput = (i, j) => {
        const { comments } = this.state
        let nextComments = deepCopy(comments)
        if (j >= 0) {
            // 대댓글
            nextComments[i].childComments[j]['reInput'] = { content: '', files: [], modify: false, focus: false }
            this.setState({ comments: nextComments, isReply: false })
            $('.recomment_re_input_wrap').hide()
            $('#child_wrap' + i + '_' + j + ' .recomment_re_input_wrap').show()
        } else {
            // 댓글
            nextComments[i]['reInput'] = { content: '', files: [], modify: false, focus: false }
            this.setState({ comments: nextComments, isReply: false })
            $('.recomment_input_wrap').hide()
            $('#item_wrap' + i + ' .recomment_input_wrap').show()
        }
    }

    openModify = (i, j) => {
        const { comments } = this.state
        let nextComments = deepCopy(comments)
        if (j >= 0) {
            // 대댓글
            nextComments[i].childComments[j]['reInput'] = {
                content: this.state.comments[i].childComments[j].content,
                files: this.state.comments[i].childComments[j].files,
                modify: true,
                focus: true,
            }
            this.setState({ comments: nextComments })
            $('.recomment_re_input_wrap').hide()
            $('#child_wrap' + i + '_' + j + ' .recomment_re_input_wrap').show()
        } else {
            // 댓글
            nextComments[i]['reInput'] = {
                content: this.state.comments[i].content,
                files: this.state.comments[i].files,
                modify: true,
                focus: true,
            }
            this.setState({ comments: nextComments })
            $('.recomment_input_wrap').hide()
            $('#item_wrap' + i + ' .recomment_input_wrap').show()
        }
    }

    reFileUpload = (e, i, j) => {
        e.preventDefault()
        let thumbnail = null
        if (j < 0) {
            thumbnail = document.querySelector('input[name="file' + i + '"]').files[0]
        } else {
            thumbnail = document.querySelector('input[name="file' + i + '_' + j + '"]').files[0]
        }
        const data = new FormData()
        data.append('file', thumbnail)

        axios
            .post(`${BACKEND_HOST}/upload/files/`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const { comments } = this.state
                let nextComments = deepCopy(comments)
                if (j < 0) {
                    nextComments[i]['reInput']['files'] = res.data
                } else {
                    nextComments[i].childComments[j]['reInput']['files'] = res.data
                }
                this.setState({ comments: nextComments })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    reDeleteFile = (i, j) => {
        const { comments } = this.state
        let nextComments = deepCopy(comments)
        if (j < 0) {
            nextComments[i]['reInput']['files'] = []
        } else {
            nextComments[i].childComments[j]['reInput']['files'] = []
        }
        this.setState({ comments: nextComments })
    }

    clickDeletebtn = (i, j) => {
        let id = ''
        if (j < 0) {
            id = this.state.comments[i]._id
        } else {
            id = this.state.comments[i].childComments[j]._id
        }
        this.setState({ deletePopId: id })
    }

    closePop = () => {
        this.setState({ deletePopId: null })
    }

    renderComment = () => {
        const List = this.state.comments.map((comment, i) => {
            return (
                <CommentItem
                    comments={comment}
                    key={comment._id}
                    loadComment={this.loadComment}
                    addComment={this.addComment}
                    deleteComment={this.deleteComment}
                    modifyComment={this.modifyComment}
                    openReInput={this.openReInput}
                    openModify={this.openModify}
                    closeReInput={this.closeReInput}
                    reChangeData={this.reChangeData}
                    reOnFocus={this.reOnFocus}
                    reOnBlur={this.reOnBlur}
                    reFileUpload={this.reFileUpload}
                    reDeleteFile={this.reDeleteFile}
                    clickDeletebtn={this.clickDeletebtn}
                    user={this.state.user}
                    index={i}
                    isReply={this.state.isReply}
                />
            )
        })
        return List
    }

    componentDidUpdate(prevProps) {
        if (this.state.isSimple) {
            this.addComment(null, null)
        }
    }

    render() {
        if (this.state.user && this.state.user.email === 'appvalid@ai-con.co.kr') {
            return <div></div>
        }
        let commentCnt = this.state.comments.length
        this.state.comments.forEach((item) => {
            commentCnt += item.childComments.length
        })
        const simpleCommentInput = [
            '감사합니다.',
            '멋져요!',
            '좋아요~',
            '수고하셨습니다.',
            '고생하셨습니다.',
            '네 알겠습니다.',
        ]
        return (
            <div className="comment_wrap">
                <div className="comment_h1">
                    댓글<span>{commentCnt}</span>
                </div>

                {this.state.comments.length > 0 ? (
                    <div className="list_wrap">{this.renderComment()}</div>
                ) : (
                    <div className="list_no_wrap">댓글이 없습니다.</div>
                )}

                {this.state.isReply && (
                    <div className="comment_simple_comment_input">
                        간단 댓글 입력
                        <div className="comment_simple_comment_input_list">
                            {simpleCommentInput.map((text, idx) => {
                                return (
                                    <div
                                        className="comment_simple_comment_input_item"
                                        key={idx}
                                        onClick={() => {
                                            this.setState((state) => {
                                                return {
                                                    ...state,
                                                    isSimple: true,
                                                    input: {
                                                        ...state.input,
                                                        content: text,
                                                    },
                                                }
                                            })
                                        }}>
                                        #{text}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )}
                {this.props.cookies.get('demo') !== 'true' && (
                    <div className={this.state.input.focus ? 'focus input_wrap' : 'blur input_wrap'}>
                        <textarea
                            placeholder="댓글을 입력하세요"
                            type="text"
                            name="content"
                            onChange={this.changeData}
                            onFocus={this.onFocus}
                            value={this.state.input.content}></textarea>
                        {this.state.input.focus && (
                            <div>
                                <div className="input_cancel_btn" onClick={() => this.onBlur()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                        <g
                                            fill="none"
                                            fillRule="evenodd"
                                            stroke="#BEC6D2"
                                            strokeLinecap="round"
                                            strokeWidth="1.7">
                                            <path d="M1 15L15 1M1 1l14 14" />
                                        </g>
                                    </svg>
                                </div>

                                {this.state.input.files && this.state.input.files.length > 0 && (
                                    <div className="input_img_wrap">
                                        <img src={this.state.input.files[0].url} alt="img" />
                                        <svg
                                            onClick={() => this.deleteFile()}
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            width="28"
                                            height="28"
                                            viewBox="0 0 28 28">
                                            <defs>
                                                <circle id="cancel_btn1" cx="14" cy="14" r="12" />
                                                <filter
                                                    id="cancel_btn2"
                                                    width="125%"
                                                    height="125%"
                                                    x="-12.5%"
                                                    y="-12.5%"
                                                    filterUnits="objectBoundingBox">
                                                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                    <feGaussianBlur
                                                        in="shadowOffsetOuter1"
                                                        result="shadowBlurOuter1"
                                                        stdDeviation="1"
                                                    />
                                                    <feComposite
                                                        in="shadowBlurOuter1"
                                                        in2="SourceAlpha"
                                                        operator="out"
                                                        result="shadowBlurOuter1"
                                                    />
                                                    <feColorMatrix
                                                        in="shadowBlurOuter1"
                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                                                    />
                                                </filter>
                                            </defs>
                                            <g fill="none" fillRule="evenodd">
                                                <g fill="#000">
                                                    <use filter="url(#cancel_btn2)" xlinkHref="#cancel_btn1" />
                                                    <circle
                                                        cx="14"
                                                        cy="14"
                                                        r="11"
                                                        fillOpacity=".55"
                                                        stroke="#FFF"
                                                        strokeLinejoin="square"
                                                        strokeWidth="2"
                                                    />
                                                </g>
                                                <path
                                                    stroke="#FFF"
                                                    strokeLinecap="round"
                                                    strokeWidth="1.7"
                                                    d="M10.437 17.516l7.079-7.08M10.437 10.437l7.079 7.079"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                )}

                                <div className="img_add_btn">
                                    <label htmlFor="file">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16">
                                            <g fill="none" fillRule="evenodd" stroke="#A2A7AE">
                                                <rect
                                                    width="14.7"
                                                    height="14.7"
                                                    x=".65"
                                                    y=".65"
                                                    strokeWidth="1.3"
                                                    rx="2"
                                                />
                                                <circle
                                                    cx="5.143"
                                                    cy="5.143"
                                                    r="1.714"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.2"
                                                />
                                                <path
                                                    strokeLinecap="square"
                                                    strokeLinejoin="round"
                                                    strokeWidth="1.3"
                                                    d="M14.857 10.494L10.93 6.857l-8.643 8"
                                                />
                                            </g>
                                        </svg>
                                        사진첨부
                                    </label>
                                    <input
                                        id="file"
                                        type="file"
                                        name="file"
                                        accept="image/*"
                                        onChange={(e) => this.fileUpload(e)}
                                    />
                                </div>
                            </div>
                        )}
                        <div className="add_btn" onClick={() => this.addComment(null, null)}>
                            댓글달기
                        </div>
                    </div>
                )}
                {this.state.deletePopId && (
                    <div className="alret_pop2_bg">
                        <div className="alret_pop2_wrap">
                            <p className="h1_text">삭제하시겠습니까?</p>
                            <p>삭제하면 복원할 수 없습니다.</p>
                            <div className="btn btn1" onClick={this.closePop}>
                                아니오
                            </div>
                            <div
                                className="btn btn2"
                                onClick={() => {
                                    this.deleteComment(this.state.deletePopId)
                                }}>
                                네
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default withCookies(CommentList)



// WEBPACK FOOTER //
// ./Src/Components/Commons/CommentList.js